module.exports = __webpack_public_path__ + "2f0dcdf1bf0beabc476e015ba80093d9.png";